import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import styled, { keyframes, ThemeContext } from 'styled-components';
import { Text } from '@awaze/design-system.components.text';
import { Stack } from '@awaze/design-system.components.stack';
import { PinLocation } from './icons';
export const PlaceholderContentStyled = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const loadingAnimation = keyframes `
  to {
    background-position: 200% center;
  }
`;
const LoaderAnimation = styled.div `
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.8) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-position: -100% center;
    background-size: 40%;
    background-repeat: no-repeat;
    animation-name: ${loadingAnimation};
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
`;
/**
 * This is an internal component for the Map
 *
 * It isn't exported and isn't expected to be used outside of the Map component
 *
 * This storybook exists to provide visibility on what these placeholders look
 * like as they can only be seen when:
 * - There was a problem with Google Maps API itself
 * - The map is in a loading state
 */
export const MapPlaceholder = ({ children, containerStyle, }) => {
    const themeContext = useContext(ThemeContext);
    const placeholderStyles = {
        ...containerStyle,
        position: 'relative',
        backgroundColor: themeContext.ColorBlackOpacity5,
    };
    return (_jsx("div", { style: placeholderStyles, children: children && (_jsx(PlaceholderContentStyled, { children: children })) }));
};
export const FailedMapPlaceholder = (props) => (_jsx(MapPlaceholder, { ...props, children: _jsxs(Stack, { spacing: 12, align: "center", children: [_jsx(PinLocation, {}), _jsx(Text, { sizes: [300, 400, 400], type: "bold", children: props.errorLabels.heading }), _jsx(Text, { children: props.errorLabels.text })] }) }));
export const LoadingMapPlaceholder = (props) => (_jsx(LoaderAnimation, { children: _jsx(MapPlaceholder, { ...props }) }));
//# sourceMappingURL=map-placeholder.js.map